export const errorBoundary = {
  title: 'Sorry~ Page crash 😩'
}

export default errorBoundary